import type { Application } from "@/lib/api/envoy";
import type { JobsStatus } from "./view";

// Imports nothing but types, so the sample (the API mock the synthetics run
// in Node) can hold its list to the same queue as the tabs.

/** Which status filter an application falls under. A skipped or closed one is only in All. */
export function statusGroup(application: Application | undefined): JobsStatus | "closed" {
    if (!application) return "open";
    switch (application.status) {
        case "MATCHED":
            return application.queued_by ? "queue" : "open";
        case "TAILORING":
        case "NEEDS_YOU":
        case "FAILED":
            return "queue";
        case "APPLIED":
            return "applied";
        case "SKIPPED":
        case "CLOSED":
            return "closed";
    }
}
